import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { AbstractMutableList192xfq8ycgofs as AbstractMutableList } from './AbstractMutableListJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { AbstractList3ck35puwbp1e9 as AbstractList } from './AbstractList.mjs';
import { IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException } from '../exceptions.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from './CollectionsKt.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../js/rangeTo.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function asReversed(_this__u8e3s4) {
  return ReversedList().am(_this__u8e3s4);
}
function asReversed_0(_this__u8e3s4) {
  return ReversedListReadOnly().cm(_this__u8e3s4);
}
var ReversedList$listIterator$1Class;
function ReversedList$listIterator$1() {
  if (ReversedList$listIterator$1Class === VOID) {
    class $ {
      constructor(this$0, $index) {
        this.em_1 = this$0;
        this.dm_1 = this$0.zl_1.u1(reversePositionIndex(this$0, $index));
      }
      n1() {
        return this.dm_1.v6();
      }
      v6() {
        return this.dm_1.n1();
      }
      o1() {
        return this.dm_1.x6();
      }
      w6() {
        return reverseIteratorIndex(this.em_1, this.dm_1.y6());
      }
      x6() {
        return this.dm_1.o1();
      }
      y6() {
        return reverseIteratorIndex(this.em_1, this.dm_1.w6());
      }
      l6() {
        return this.dm_1.l6();
      }
    }
    initMetadataForClass($);
    ReversedList$listIterator$1Class = $;
  }
  return ReversedList$listIterator$1Class;
}
var ReversedListClass;
function ReversedList() {
  if (ReversedListClass === VOID) {
    class $ extends AbstractMutableList() {
      static am(delegate) {
        var $this = this.e7();
        $this.zl_1 = delegate;
        return $this;
      }
      p1() {
        return this.zl_1.p1();
      }
      q1(index) {
        return this.zl_1.q1(reverseElementIndex(this, index));
      }
      v3() {
        return this.zl_1.v3();
      }
      z3(index) {
        return this.zl_1.z3(reverseElementIndex(this, index));
      }
      fm(index, element) {
        return this.zl_1.b2(reverseElementIndex(this, index), element);
      }
      b2(index, element) {
        return this.fm(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      gm(index, element) {
        this.zl_1.y3(reversePositionIndex(this, index), element);
      }
      y3(index, element) {
        return this.gm(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      m1() {
        return this.u1(0);
      }
      u1(index) {
        return new (ReversedList$listIterator$1())(this, index);
      }
    }
    initMetadataForClass($, 'ReversedList');
    ReversedListClass = $;
  }
  return ReversedListClass;
}
var ReversedListReadOnly$listIterator$1Class;
function ReversedListReadOnly$listIterator$1() {
  if (ReversedListReadOnly$listIterator$1Class === VOID) {
    class $ {
      constructor(this$0, $index) {
        this.im_1 = this$0;
        this.hm_1 = this$0.bm_1.u1(reversePositionIndex(this$0, $index));
      }
      n1() {
        return this.hm_1.v6();
      }
      v6() {
        return this.hm_1.n1();
      }
      o1() {
        return this.hm_1.x6();
      }
      w6() {
        return reverseIteratorIndex(this.im_1, this.hm_1.y6());
      }
      x6() {
        return this.hm_1.o1();
      }
      y6() {
        return reverseIteratorIndex(this.im_1, this.hm_1.w6());
      }
    }
    initMetadataForClass($);
    ReversedListReadOnly$listIterator$1Class = $;
  }
  return ReversedListReadOnly$listIterator$1Class;
}
var ReversedListReadOnlyClass;
function ReversedListReadOnly() {
  if (ReversedListReadOnlyClass === VOID) {
    class $ extends AbstractList() {
      static cm(delegate) {
        var $this = this.ti();
        $this.bm_1 = delegate;
        return $this;
      }
      p1() {
        return this.bm_1.p1();
      }
      q1(index) {
        return this.bm_1.q1(reverseElementIndex(this, index));
      }
      m1() {
        return this.u1(0);
      }
      u1(index) {
        return new (ReversedListReadOnly$listIterator$1())(this, index);
      }
    }
    initMetadataForClass($, 'ReversedListReadOnly');
    ReversedListReadOnlyClass = $;
  }
  return ReversedListReadOnlyClass;
}
function reverseElementIndex(_this__u8e3s4, index) {
  var tmp;
  if (0 <= index ? index <= get_lastIndex(_this__u8e3s4) : false) {
    tmp = get_lastIndex(_this__u8e3s4) - index | 0;
  } else {
    throw IndexOutOfBoundsException().je('Element index ' + index + ' must be in range [' + numberRangeToNumber(0, get_lastIndex(_this__u8e3s4)).toString() + '].');
  }
  return tmp;
}
function reversePositionIndex(_this__u8e3s4, index) {
  var tmp;
  if (0 <= index ? index <= _this__u8e3s4.p1() : false) {
    tmp = _this__u8e3s4.p1() - index | 0;
  } else {
    throw IndexOutOfBoundsException().je('Position index ' + index + ' must be in range [' + numberRangeToNumber(0, _this__u8e3s4.p1()).toString() + '].');
  }
  return tmp;
}
function reverseIteratorIndex(_this__u8e3s4, index) {
  return get_lastIndex(_this__u8e3s4) - index | 0;
}
//region block: exports
export {
  asReversed as asReversed2y2qzr7vrqd5,
  asReversed_0 as asReversed308kw52j6ls1u,
};
//endregion

//# sourceMappingURL=ReversedViews.mjs.map
